/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S9_HeadingInputs */

const tr_onbilgi_s9_heading = /** @type {(inputs: Onbilgi_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Şikayet ve Uyuşmazlık Yolları`)
};

const en_onbilgi_s9_heading = /** @type {(inputs: Onbilgi_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Complaint and Dispute Resolution Channels`)
};

const de_onbilgi_s9_heading = /** @type {(inputs: Onbilgi_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Beschwerde- und Streitbeilegungswege`)
};

const ru_onbilgi_s9_heading = /** @type {(inputs: Onbilgi_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Порядок подачи жалоб и разрешения споров`)
};

/**
* | output |
* | --- |
* | "9. Complaint and Dispute Resolution Channels" |
*
* @param {Onbilgi_S9_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s9_heading = /** @type {((inputs?: Onbilgi_S9_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S9_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s9_heading(inputs)
	if (locale === "de") return de_onbilgi_s9_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s9_heading(inputs)
	return tr_onbilgi_s9_heading(inputs)
});